// extracted by mini-css-extract-plugin
export default {"CheckBox":"CheckBox_CheckBox__nGnRT","LabelText":"CheckBox_LabelText__6OPV-","Required":"CheckBox_Required__zl383"};